import { render, staticRenderFns } from "./AdvisorCard.vue?vue&type=template&id=5e693922&scoped=true&"
import script from "./AdvisorCard.vue?vue&type=script&lang=js&"
export * from "./AdvisorCard.vue?vue&type=script&lang=js&"
import style0 from "./AdvisorCard.vue?vue&type=style&index=0&id=5e693922&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e693922",
  null
  
)

export default component.exports